import React from 'react';
import PropTypes from 'prop-types';

import {injectIntl} from 'react-intl';
import {reduxForm, Field} from 'redux-form';

import {channelImageUrl} from '../../containers/channelUtils/ChannelImage';
import defaultAvatar from '../../assets/images/avatar_default.svg';

import Button from '../button/Button';
import FieldProfilePictureInput from '../fields/fieldProfilePictureInput/FieldProfilePictureInput';
import FieldText from '../fields/fieldText/FieldText';

@injectIntl
@reduxForm({
  form: 'profile'
})
export default class ProfileForm extends React.PureComponent {
  render() {
    const {intl, currentAvatar, children, onPasswordReset, handleSubmit, submitting, error} = this.props;

    return (
      <form className="profile" onSubmit={handleSubmit}>

        <div className="profile__general">
          <Field
            name="avatar"
            label={intl.formatMessage({id: 'section.profile.change-avatar'})}
            emptyValuePreview={currentAvatar ? channelImageUrl(currentAvatar.path) : defaultAvatar}
            component={FieldProfilePictureInput}
          />

          <div className="profile__form  form">
            {error && <p className="form__error">{error}</p>}

            <Field
              name="username"
              type="text"
              label={intl.formatMessage({id: 'section.profile.name'})}
              component={FieldText}
              placeholder={intl.formatMessage({id: 'section.profile.name-placeholder'})}
            />

            <Field
              disabled
              name="email"
              type="email"
              label={intl.formatMessage({id: 'section.profile.email'})}
              component={FieldText}
              placeholder="example@mail.com"
            />

            <a
              className="profile__password"
              onClick={onPasswordReset}
            >
              {intl.formatMessage({id: 'section.profile.change-password'})}
            </a>
          </div>
        </div>

        <h5 className="profile__subheader">
          {intl.formatMessage({id: 'section.profile.contact-information'})}
        </h5>

        <div className="profile__contacts">
          <Field
            name="discordUsername"
            label="Discord"
            component={FieldText}
            placeholder="Name#1234"
          />

          <Field
            name="skypeUsername"
            label="Skype"
            className="input"
            component={FieldText}
            placeholder="skypelogin"
          />
        </div>

        <hr/>

        {children}

        <div className="profile__contacts">
          <Button filled full loading={submitting} disabled={submitting}>
            {intl.formatMessage({id: 'section.generic.save-changes'})}
          </Button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/profile/ProfileForm.js